import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getFabTheme } from '../../config/MaterialTheme';

import styles from './CustomIconButton.scss';
import { Fab, Icon, MuiThemeProvider, Badge } from '@material-ui/core';
import TooltipCaller from '../TooltipManager/TooltipCaller';
import { getMergedClassNames } from '../../utils/HTMLUtils';

const rootClassName = styles.rootClassName;

class CustomIconButton extends Component {
  getImageIcon() {
    return (
      <img
        className={rootClassName + '-image-icon'}
        src={this.props.icon}
        alt='icone-button'
        loading='lazy'
      />
    );
  }

  getIcon() {
    if (typeof this.props.icon === 'string') {
      if (this.props.icon.indexOf('.') > -1) {
        return this.getImageIcon();
      } else {
        return (
          <Icon className={rootClassName + '-icon'}>{this.props.icon}</Icon>
        );
      }
    }
    if (typeof this.props.icon === 'object') {
      return this.props.icon;
    }
  }

  getClassNames() {
    let classNames = [rootClassName];
    if (this.props.className) {
      classNames.push(this.props.className);
    }
    return classNames.join(' ');
  }

  getTooltipCaller(children) {
    let props = { ...(this.props.tooltipProps || {}) };
    props.className = getMergedClassNames([
      rootClassName + '-tooltip-caller',
      props.className || '',
    ]);
    if (this.props.tooltip && this.props.tooltip.length > 0) {
      props.text = this.props.tooltip;
      return <TooltipCaller {...props}>{children}</TooltipCaller>;
    } else {
      return children;
    }
  }

  getBadge = (children) => {
    if (typeof this.props.counter === 'number' && this.props.counter > 0) {
      return (
        <Badge
          overlap='rectangular'
          badgeContent={this.props.counter}
          color='error'
          className={this.getClassNames()}
        >
          {children}
        </Badge>
      );
    }
    return children;
  };

  render() {
    const theme = this.props.theme;
    const fabProps = {
      id: this.props.id || null,
      className: this.getClassNames(),
      onClick: this.props.onClick,
      disabled: this.props.disabled,
      size: this.props.size ? this.props.size : 'large',
    };
    return this.getTooltipCaller(
      <MuiThemeProvider theme={getFabTheme(theme)}>
        {this.getBadge(
          <Fab color='primary' {...fabProps}>
            {this.getIcon()}
            {this.props.children || null}
          </Fab>
        )}
      </MuiThemeProvider>
    );
  }
}

CustomIconButton.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
  tooltipProps: PropTypes.object,
  tooltip: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.any,
};

export default CustomIconButton;
